<template>
    <header class="main-header">
        <div class="sloth-container">
            <nav class="navbar">
                <div class="navbar-info">
                    <router-link  :to="'/'">
                        <img src="/assets/images/header.png" alt="">
                    </router-link>
                    <button :class="{'navbar-trigger': true, 'open': isOpen }" @click="isOpen = !isOpen">
                        <i class="navbar-burger"></i>
                        <i class="navbar-burger"></i>
                        <i class="navbar-burger"></i>
                    </button>
                </div>
                <ul :class="{'navbar-list': true, 'open': isOpen }">
                    <li class="navbar-item">
                        <router-link class="navbar-link" :to="'/'">
                            <span @click="close">{{$t('navigation.home_title')}}</span>
                        </router-link>
                    </li>
                    <li class="navbar-item">
                        <router-link class="navbar-link" :to="'/#'+$t('routes.about')">
                            <span @click="close">{{$t('navigation.about_us_title')}}</span>
                        </router-link>
                    </li>
                    <!--
                    <li class="navbar-item">
                        <a @blur="close" class="navbar-link" :href="'/#'+$t('routes.work')">{{$t('navigation.works_title')}}</a>
                    </li>
                    -->
                    <li class="navbar-item">
                        <router-link class="navbar-link" :to="'/#'+$t('routes.services')">
                            <span @click="close">{{$t('navigation.services_title')}}</span>
                        </router-link>
                    </li>
                    <li class="navbar-item">
                        <router-link class="navbar-link" :to="'/#'+$t('routes.community')">
                            <span @click="close">{{$t('navigation.community_title')}}</span>
                        </router-link>
                    </li>
    
                    <li class="navbar-item">
                        <router-link class="navbar-link" :to="'/#'+$t('routes.contact')">
                            <span @click="close">{{$t('navigation.contact_title')}}</span>
                        </router-link>
                    </li>
    
                    <li class="navbar-item">
                        <SelectLang @click="close" />
                    </li>
                </ul>
            </nav>
        </div>
    </header>
</template>

<script>
    import SelectLang from "./SelectLang.vue";
    export default {
        name: "MainNavbar",
        components: {
            SelectLang
        },
        data() {
            return {
                isOpen: false
            };
        },
        methods: {
            close() {
                this.isOpen = false;
            }
        }
    };
</script>
